import React, { useContext } from 'react';
import { CopyContext } from '../provider/MyProvider';
import './About.css';

export const About = () => {
    const { aboutCards } = useContext(CopyContext);

    const renderCards = aboutCards.map((card) => {
        return (
            <div className="about-card">
                <img 
                    src={card.img} 
                    alt={card.title} 
                />
                <div className="about-text">
                    <h4>{card.title}</h4>
                    <p className="list">{card.description}</p>
                </div>
            </div>
        )
    });

  return (
    <section className="about">
        
        <div className="about-header">
            <h1>No Fluff Guarantee®</h1>
            <p>Ok, it's not actually trademarked.  But we are laser-focused on only the most impactful features that save you time and get more deals done.</p>
        </div>

        <div className="about-card-container">
            {renderCards}
        </div>
        
    </section>
  );
};